export const en = {
  home: {
    title: "",
  },
};
